<div class="modal-backdrop" (click)="onCancel()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Assign Pricing Group</h2>
      <button class="close-btn" (click)="onCancel()">&times;</button>
    </div>
    <div class="modal-body">
      <div class="agent-info-card">
        <div class="agent-info-header">
          <i class="fas fa-user"></i>
          <h3>{{ agent.name }}</h3>
        </div>
        <div class="agent-details">
          <div class="detail-row">
            <span class="label">Phone:</span>
            <span class="value">{{ agent.phoneNumber }}</span>
          </div>
          <div class="detail-row">
            <span class="label">Current Pricing Group:</span>
            <span class="value">{{ getPricingGroupName(agent.pricingGroupId) }}</span>
          </div>
        </div>
      </div>

      <form (submit)="onSubmit()" class="assign-form">
        <div class="error-message" *ngIf="errors['general']">
          <i class="fas fa-exclamation-circle"></i> {{ errors['general'] }}
        </div>

        <div class="form-group">
          <label class="form-label" for="pricingGroupSelect">
            Select Pricing Group
          </label>
          <select id="pricingGroupSelect" [(ngModel)]="selectedGroupId" name="pricingGroup" class="form-select">
            <option value="">Global</option>
            <option *ngFor="let group of pricingGroups" [value]="group.id">{{ group.name }}</option>
          </select>
        </div>

        <div class="form-actions">
          <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
          <button type="submit" class="btn btn-primary" [disabled]="isSubmitting || isLoadingGroups">
            <span *ngIf="isSubmitting"><i class="fas fa-spinner fa-spin"></i> Saving...</span>
            <span *ngIf="!isSubmitting">Assign Pricing Group</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
